/* src/app/shared/components/form-controls/ag-input-v2/ag-input-v2.component.scss */
.ag-form-control {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 254px;
  height: 48px;
  border-radius: 12px;
  background-color: #f2f2f2;
  border: none;
  padding: 0 16px 12px 16px;
}
.ag-value {
  font-size: 14px;
  font-family: "Poppins-Regular";
  line-height: 24px;
  color: #222222;
}
input {
  width: 220px;
  background-color: #f2f2f2;
}
/*# sourceMappingURL=ag-input-v2.component.css.map */
